import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import styles from './RequestDetails.module.css'
import { _ToNormal, setDate } from "../../../../../Utils/helper";
import { DOCUMENT_PREVIEW, GENERATE_ONE_TIME_PDF_LINK, GET_HOLDER_SHARED_DATA } from "../../../../../Utils/constant";
import Error from "../../../../../components/OnBoard/Error";
import API from '../../../../../ApiConfig'
import Icon from "react-icons-kit";
import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack'
import SlideUpWrapper from "../../../../../components/Transitions/SlideUpWrapper";
import ReactPortalModal from "../../../../../components/ReactPortalModal";
import cogoToast from "cogo-toast-react-17-fix";

export default function EMPRequestDetails() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const { request_id, issuer_id, verification_request_id } = useParams();

    const [preview, setPreview] = useState(null)
    const [title, setTitle] = useState('Preview Document')
    const [pdfLoading, setPDFloading] = useState(null)
    const [issuedDocId, setIssuedDocId]=useState("")
    const [AppealDocPopup, setAppealDocPopup]=useState(false)
    const [raisedAppealDocs, setRaisedAppealDocs]=useState([])

    const [AppealPopupStatus, setAppealPopupStatus]=useState(null)

    const [AppealDocs, setAppealDoc]=useState([])
    const getPdf = (key, item, index, source) => {
        setTitle(key)
        setPDFloading(index)
        API.get(DOCUMENT_PREVIEW + item,source=="scan-qr"&&{
            responseType: "blob"
          })
            .then(response => {
                setPDFloading(null)
                if(response.headers["content-type"]?.includes("application/pdf")){
                    const pdfUrl = URL.createObjectURL(response.data);
                    
                    setPreview(pdfUrl)
                    
                    
                }
                else{
                setPreview(response.data.data.pdf);
                }
            }).catch(err => {
                setPDFloading(null);
                setPreview(null)
            })
    }

    console.log(verification_request_id);
    
    const DocPreview = () => {
        var loading = {
            padding: "1rem",
            height: "10vh",
            width: "-webkit-fill-available",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
        if (!preview) {
            return (<div style={loading}>
                {loadingText}
            </div>)
        }
        else {
            return (
                <embed
                    id="pdf-viewer"
                    src={preview + "#toolbar=0"}
                    type="application/pdf"
                    style={{width:"700px", height:"500px"}}
                />
            )
        }
    }
    const AppealDocuments = () => {
            return (
                <>
                <div className={styles.AppealList}>
                    <p style={{color:"gray", fontSize:"16px", margin:"10px 0px"}}> Select Document on which you want to raise appeal</p>
                    {AppealDocs.map((i, index)=>(
                        <div key={index} className={styles.AppealDoc} onClick={()=>navigate(`../emp/appeal/${i.issued_doc_id}/${issuer_id}/${verification_request_id}`, {state:{request_id:request_id}})}>
                           <div> <img src={i.icon} alt="Doc image" loading="lazy"/> </div>
                            {i.appeal_doc}
                        </div>

                    ))}
                </div>
                </>
            )
    }
    const AppealStatusDocuments = () => {
        return (
            <>
            <div className={styles.AppealList}>
                <p style={{color:"gray", fontSize:"16px", margin:"10px 0px"}}> Select Document on which you want to check appeal status</p>
                {raisedAppealDocs.map((i, index)=>(
                    <div key={index} className={styles.AppealDoc} onClick={()=>navigate(`../emp/appeal/${i.issued_doc_id}/${issuer_id}/${verification_request_id}`, {state:{request_id:request_id}})}>
                       <div> <img src={i.icon} alt="Doc image" loading="lazy"/> </div>
                        {i.appeal_doc}
                    </div>

                ))}
            </div>
            </>
        )
}

    useEffect(() => {
        // setData({
        //     "name": "Aviral",
        //     "email": "aviral.sharma@authbridge.com",
        //     "phone_number": "9911416415",
        //     "created_at": "2024-12-17T17:42:51.939355",
        //     "form_type": "document",
        //     "shared_data": {
        //         "name": "Aviral",
        //         "email": "aviral.sharma@authbridge.com",
        //         "Experience Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "New Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Old Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Another Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        //         "Experience Letter": 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
        //     }
        // })
        getSharedData()
    }, [])
    const getSharedData=()=>{
        setLoading(true)
        API.get(GET_HOLDER_SHARED_DATA + request_id)
            .then(res => {
                if (res.data.status === 200) {
                    const result=res.data.data
                    setData(result)
                    setAppealDoc(result.AppealDocs)
                    setRaisedAppealDocs(result.raised_appeal)
                    let issued_doc_id=null
                    if (result.form_type === 'Document' && result.shared_data) {
                        for (const [key, value] of Object.entries(result.shared_data)) {
                            if (Number.isInteger(value)) {
                                issued_doc_id = value;
                                break;
                            }
                        }
                    }
                    setIssuedDocId(issued_doc_id)
                }
            })
            .catch(err => {
                cogoToast.error(err.response.data.detail)
                setData(1)
            })
            .finally(() => setLoading(false))
    }
    const handleCreateAppeal=(e, status)=>{
        e.preventDefault()
        setAppealPopupStatus(status)
        setAppealDocPopup(true)

    }
    const getPdfLink=(e)=>{
        setLoading(true)
        e.preventDefault()
        API.post(GENERATE_ONE_TIME_PDF_LINK+request_id)
        .then(res=>{
            setLoading(false)
            if(res.status==200){
                getSharedData()
            }

        })
        .catch(err=>{
            cogoToast.error(err.response.data.message)
        })
    }

    if (data == 1) {
        return <Error Message="Invalid Request ID" />
    }
    return (
        <div style={{ width: "100%" }}>
            <SlideUpWrapper direction='slide-left'>
                <div>
                    <h2 className={styles.header} style={{justifyContent:"space-between"}}>
                        <div>
                        <Icon icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate('../emp/requests')} style={{ cursor: 'pointer', paddingRight:"7px" }} />
                        {loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.name}
                        </div> 
                        {(data.create_appeal || data.appeal_raised) &&
                        <div className={styles.AppealBtn}>
                        {data?.AppealDocs && data?.AppealDocs.length>0 &&
                        <div>
                            <button className="btn btn-primary"onClick={(e)=>handleCreateAppeal(e, "Appeal")}>{"Create Appeal"}</button>
                        </div>}
                        {data. raised_appeal && data?.raised_appeal.length>0 &&
                        <div>
                            <button className="btn btn-primary"onClick={(e)=>handleCreateAppeal(e, "Status")}>{"Check Appeal Status"}</button>
                        </div>}
                        </div>}
                    </h2>
                    <div className={styles.section}>
                        <div className={styles.mainContainer}>
                            <div className={styles.tableHeader}>
                                <span className="heading">{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.name}</span>
                                <div className={styles.basicDetails}>
                                    {/* <div>
                                        <span className="heading">Phone</span>
                                        <span>{loading ? <div className="shimmer" /> : data.phone_number}</span>
                                    </div>
                                    <div>
                                        <span className="heading">Email</span>
                                        <span>{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.email}</span>
                                    </div> */}
                                    <div>
                                        <span className="heading">Searched on</span>
                                        <span>{loading ? <div className="shimmer" /> : setDate(data.created_at)}</span>
                                    </div>
                                </div>
                                {data?.remarks &&
                                <div>
                                        <span className="heading">Remarks</span>
                                        <span>{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data.remarks || 'NA'}</span>
                                </div>}
                            </div>
                            <table style={{ width: '100%', textAlign: 'left' }}>
                                <tbody>
                                    {data.shared_data && Object.entries(data.shared_data).map(([key, value], index) => (
                                        <tr key={index} className="credentials-header1" style={{ alignItems: 'center' }}>
                                            <td className="credentials-td" style={{ justifyContent: 'flex-start', maxWidth: '10rem' }}>{_ToNormal(key)}</td>
                                            <td className="credentials-td" style={{ justifyContent: 'flex-start' }}>{
                                                Number.isInteger(value) && data.form_type == 'Document' ?
                                                    <button
                                                        className="btn btn-secondary"
                                                        onClick={e => {
                                                            if (!pdfLoading)
                                                                getPdf(key, value, index, data.source)
                                                        }}
                                                        style={{ display: 'flex', gap: '0.3rem', textDecoration: 'none' }}>
                                                        <img
                                                            className={styles.downloadOutlineIcon}
                                                            alt=""
                                                            src="/downloadoutline.svg"
                                                        />
                                                        {pdfLoading == index ? 'Loading...' : 'Download PDF'}</button>
                                                    :
                                                    typeof value=="string" && value.includes('https') ? <img src={value} width={'200px'} height={'200px'} /> : value!=null?(value):"Document Link Expired"
                                            }{value == null && data.can_generate_pdf_link && (
                                                <button
                                                className="btn btn-primary"
                                                  onClick={(e) => getPdfLink(e)}
                                                >
                                                    Refresh Link
                                                </button>)}
                                            </td>
                                        </tr>
))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className={styles.section} style={{margin:"10px 0px"}}>
                        <ul>
                    {!data.hide_pdf &&    <li style={{fontSize:"18px", color:"red"}}>The document link is valid for 7 days only. Kindly complete the verification within this period.</li>}
                        <li style={{fontSize:"18px", color:"red"}}>An appeal can be raised within 15 days from the date of receiving the verified data.</li>
                        <li style={{fontSize:"18px", color:"red"}}>Once the document link expires, a “Refresh Link” button will appear and can be used only once to generate a new download link valid for 24 hours.</li>
                        </ul>
                    </div>
                    <ReactPortalModal title={title} isOpen={preview} onClose={e => setPreview(null)}>
                        <DocPreview />
                    </ReactPortalModal>
                    {AppealDocPopup && (
                        <ReactPortalModal isOpen={AppealDocPopup} onClose={() => setAppealDocPopup(null)} title="Select Document">
                            {AppealPopupStatus==="Appeal" ? <AppealDocuments /> : <AppealStatusDocuments />}
                        </ReactPortalModal>
                    )}
                </div>
            </SlideUpWrapper>
        </div>
    );
};
